import { createWebHistory, createRouter } from 'vue-router'
import Home from './components/Home.vue'
import RequiredDisclosure from './components/RequiredDisclosure.vue'
import EmploymentOutcomes from './components/EmploymentOutcomes.vue'
import BarPassageOutcomes from './components/BarPassageOutcomes.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/requiredDisclosure', component: RequiredDisclosure },
  { path: '/employmentOutcomes', component: EmploymentOutcomes },
  { path: '/barPassageOutcomes', component: BarPassageOutcomes },
  {
      path: '/Disclosure509.aspx', // Match any URL ending in .aspx
      redirect: '/requiredDisclosure',
  },
  {
      path: '/EmploymentOutcomes.aspx', // Match any URL ending in .aspx
      redirect: '/employmentOutcomes',
  },
  {
      path: '/BarPassageOutcomes.aspx', // Match any URL ending in .aspx
      redirect: '/barPassageOutcomes',
  },
  {
      path: '/MainHome.aspx', // Match any URL ending in .aspx
      redirect: '/',
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})
export default router